/**
 * useRuleText — Story 2.3-UI (Split-Editor)
 *
 * Regel-Text gemaess Vorlage splits.html, z.B. „30 % vom HNT-Ertrag“,
 * „12 % vom GB-Volumen“ oder „Fixbetrag 5,00 EUR“. Eigenes Modul, damit
 * SplitRuleList.tsx nur Komponenten exportiert (react-refresh).
 */
import { useTranslation } from 'react-i18next'
import { formatNumber } from '../../components/ui'
import type { HostSplitRule } from './useSplitRules'

export function useRuleText() {
  const { t } = useTranslation('splits')
  return (rule: HostSplitRule): string => {
    if (rule.split_type === 'fixed_amount') {
      return t('ruleText.fixed', {
        value: formatNumber(rule.fixed_amount ?? 0, 2),
        currency: rule.payout_currency ?? '',
      })
    }
    const value = rule.percentage ?? 0
    const formatted = formatNumber(value, Number.isInteger(value) ? 0 : 2)
    return rule.basis === 'gigabytes_transferred'
      ? t('ruleText.percentOfGb', { value: formatted })
      : t('ruleText.percentOfHnt', { value: formatted })
  }
}
